import { createSlatePlugin } from '@udecode/plate';

import type { TMediaElement } from '..';

export interface TVideoElement extends TMediaElement {}

export const BaseVideoPlugin = createSlatePlugin({
    key: 'video',
    node: {
        dangerouslyAllowAttributes: ['width', 'height'],
        isElement: true,
        isVoid: true,
    },
});
